import makeService from './api';

export default makeService('step_fields');
